// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
// import Header from '../Components/Header';
// import { useSelector } from 'react-redux';

// export const AllListingPage = () => {
//     const { configUrl } = useSelector((state) => state.cart);
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const [products, setProducts] = useState(state?.products || []);
//   const [filteredProducts, setFilteredProducts] = useState(state?.products || []);
//   const [loading, setLoading] = useState(!state?.products);
//   const [filters, setFilters] = useState({
//     menu: '',
//     subcategory: '',
//     priceRange: [0, 1000],
//   });

//   const [selectedOption, setSelectedOption] = useState("NewestFirst");
//   const [showSortDropdown, setShowSortDropdown] = useState(false);
//   const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState('');

//   const maxPrice = Math.max(...products.map(p => p.price), 10);

//   const menus = ['men', 'women', 'kids'];
//   const subcategories = [...new Set(products.map(product => product.subcategory_slug))];

//   useEffect(() => {
//     let result = [...products];

//     if (filters.menu) {
//       result = result.filter(product => product.menu_slug === filters.menu);
//     }

//     if (filters.subcategory) {
//       result = result.filter(product => product.subcategory_slug === filters.subcategory);
//     }

//     result = result.filter(product =>
//       product.price >= filters.priceRange[0] &&
//       product.price <= filters.priceRange[1]
//     );

//     if (selectedOption === 'lowToHigh') {
//       result.sort((a, b) => a.price - b.price);
//     } else if (selectedOption === 'highToLow') {
//       result.sort((a, b) => b.price - a.price);
//     } // "NewestFirst" could be based on ID or created date if available

//     setFilteredProducts(result);
//   }, [filters, products, selectedOption]);

//   const handleFilterChange = (filterType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [filterType]: value
//     }));
//   };

//   const handlePriceRangeChange = (min, max) => {
//     setFilters(prev => ({
//       ...prev,
//       priceRange: [min, max]
//     }));
//   };

//   const handleProductClick = (slug) => {
//     navigate(`/product/${slug}`);
//   };

//   const handleToggleDropdown = () => {
//     setShowSortDropdown((prev) => !prev);
//   };

//   const handleSelectChange = (event) => {
//     setSelectedOption(event.target.value);
//     setShowSortDropdown(false);
//   };

//   const applyFilter = () => {
//     alert("Filters Applied!");
//   };

//   if (loading) {
//     return <div>Loading products...</div>;
//   }

//   return (
//     <div className="body-container">
//
//       <main className="content-main" style={{ backgroundColor: "white" }}>
//         <div className="container-main">
//           <div className="page-layout">
//             <div className="page-layout-wrapper" style={{ marginTop: "78px" }}>
//               {/* Filters Sidebar */}
//               <aside className="sidebar1">
//                 <div className="filter-section">
//                   <h3>Filters</h3>

//                   {/* Sort Dropdown */}
//                   <div className="filter-group dropdown-section">
//                     <h4>SORT BY</h4>
//                     <div className="dropdown-wrapper" onClick={handleToggleDropdown}>
//                       <select
//                         id="dropdown"
//                         value={selectedOption}
//                         onChange={handleSelectChange}
//                         className="custom-select"
//                       >
//                         <option value="NewestFirst">Newest First</option>
//                         <option value="lowToHigh">Price: Low to High</option>
//                         <option value="highToLow">Price: High to Low</option>
//                       </select>
//                       <span className="dropdown-icon">
//                         {showSortDropdown ? <FaAngleUp /> : <FaAngleDown />}
//                       </span>
//                     </div>
//                   </div>

//                   {/* Menu Filter */}
//                   <div className="filter-group dropdown-section">
//                     <h4
//                       className="dropdown-header"
//                       onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
//                       style={{ cursor: "pointer" }}
//                     >
//                       Menu {showCategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
//                     </h4>
//                     {showCategoryDropdown && (
//                       <div className="category-boxes">
//                         {menus.map((menu) => (
//                           <button
//                             key={menu}
//                             className={`category-box ${
//                               filters.menu === menu ? "selected" : ""
//                             }`}
//                             onClick={() => handleFilterChange("menu", menu)}
//                             style={{ fontSize: "14px" }}
//                           >
//                             {menu.charAt(0).toUpperCase() + menu.slice(1)}
//                           </button>
//                         ))}
//                       </div>
//                     )}
//                   </div>

//                   <button className="filter-button" onClick={applyFilter}>
//                     Apply Filters
//                   </button>
//                 </div>
//               </aside>

//               {/* Product Listing */}
//               <section className="main-content" style={{ height:"90vh" }}>
//                 <div className="product-listing">
//                   <div className="product-grid">
//                     {filteredProducts.length > 0 ? (
//                       filteredProducts.map((product) => (
//                         <div key={product.id} className="product-card">
//                           <div className="product-box">
//                             <div className="product-image-wrapper">
//                               <a
//                                 href="#"
//                                 className="product-link1"
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   handleProductClick(product.slug);
//                                 }}
//                               >
//                                 <img
//                                   src={product.image}
//                                   alt={product.name}
//                                   className="product-image"
//                                   style={{
//                                     width: "100%",
//                                     height: "100%",
//                                     maxHeight: "100%",
//                                   }}
//                                 />
//                                 {product.second_image && (
//                                   <img
//                                   src={`${configUrl}${product?.second_image}`}
//                                     alt={product.name}
//                                     className="hover-image"
//                                   />
//                                 )}
//                               </a>
//                             </div>
//                             <div className="product-info">
//                               <a
//                                 href="#"
//                                 className="product-name"
//                                 style={{
//                                   display: "inline-block",
//                                   whiteSpace: "nowrap",
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                   maxWidth: "97%",
//                                   verticalAlign: "middle",
//                                   fontSize: "16px",
//                                 }}
//                               >
//                                 {product.name}
//                               </a>
//                               <div className="product-price" style={{ fontSize: "14px" }}>
//                                 Unit price: <span>${product.price}</span>
//                               </div>
//                               <div className="product-mrp" style={{ fontSize: "14px" }}>
//                                 MRP: <span className="mrp">${product.mrp}</span>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ))
//                     ) : (
//                       <div className="product-not-found">
//                         <h3>No Products Found</h3>
//                         <p>Try adjusting your filters or browse other categories.</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </section>
//             </div>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaFilter, FaAngleUp, FaAngleDown, FaTimes } from "react-icons/fa";
import Header from "../Components/Header";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FaRegHeart } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa";
import { addFavorite, removeFavorite } from "../../Redux/Cart_System";

const SkeletonLoader = () => {
  return (
    <div className="skeleton-container">
      {/* Skeleton for filters sidebar */}
      <div className="skeleton-sidebar">
        <div className="skeleton-filter-title"></div>
        <div className="skeleton-filter-section">
          <div className="skeleton-filter-header"></div>
          <div className="skeleton-dropdown"></div>
        </div>
        <div className="skeleton-filter-section">
          <div className="skeleton-filter-header"></div>
          <div className="skeleton-category-buttons">
            <div className="skeleton-category-btn"></div>
            <div className="skeleton-category-btn"></div>
            <div className="skeleton-category-btn"></div>
          </div>
        </div>
      </div>

      {/* Skeleton for product grid */}
      <div className="skeleton-main-content">
        <div className="skeleton-product-grid">
          {Array(8)
            .fill(0)
            .map((_, index) => (
              <div key={index} className="skeleton-product-card">
                <div className="skeleton-product-image"></div>
                <div className="skeleton-product-info">
                  <div className="skeleton-product-name"></div>
                  <div className="skeleton-product-price"></div>
                  <div className="skeleton-product-mrp"></div>
                </div>
              </div>
            ))}
        </div>
      </div>

      <style jsx>{`
        .skeleton-container {
          display: flex;
          padding: 20px;
          gap: 20px;
          background: white;
          min-height: 100vh;
          margin-top: 78px;
        }

        .skeleton-sidebar {
          width: 250px;
          flex-shrink: 0;
        }

        .skeleton-main-content {
          flex: 1;
        }

        .skeleton-filter-title {
          height: 24px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 20px;
          width: 80px;
        }

        .skeleton-filter-section {
          margin-bottom: 24px;
        }

        .skeleton-filter-header {
          height: 18px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 12px;
          width: 120px;
        }

        .skeleton-dropdown {
          height: 40px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
          width: 100%;
        }

        .skeleton-category-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .skeleton-category-btn {
          height: 32px;
          width: 60px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
        }

        .skeleton-product-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 20px;
        }

        .skeleton-product-card {
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          overflow: hidden;
          background: white;
        }

        .skeleton-product-image {
          height: 250px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }

        .skeleton-product-info {
          padding: 16px;
        }

        .skeleton-product-name {
          height: 20px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 8px;
          width: 80%;
        }

        .skeleton-product-price {
          height: 16px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 6px;
          width: 60%;
        }

        .skeleton-product-mrp {
          height: 16px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
          width: 50%;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </div>
  );
};

export const AllListingPage = () => {
  const { configUrl } = useSelector((state) => state.cart);
  const [isLoading, setIsLoading] = useState(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [products, setProducts] = useState(state?.products || []);
  const [filteredProducts, setFilteredProducts] = useState(
    state?.products || []
  );
  console.log("filteredProducts  : ", filteredProducts);
  const [loading, setLoading] = useState(!state?.products);
  const [filters, setFilters] = useState({
    menu: "",
    category: "",
    subcategory: "",
    priceRange: [0, 1000],
  });

  const [selectedOption, setSelectedOption] = useState("NewestFirst");
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [showMenuDropdown, setShowMenuDropdown] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showSubcategoryDropdown, setShowSubcategoryDropdown] = useState(false);

  const maxPrice = Math.max(...products.map((p) => p.price), 10);

  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const toggleMobileFilter = () => {
    setIsMobileFilterOpen(!isMobileFilterOpen);
  };

  const dispatch = useDispatch();

  const { tokenDetails } = useSelector((state) => state.user);

  const favorites = useSelector((state) => state.cart.favorites);

  useEffect(() => {
    if (isMobileFilterOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobileFilterOpen]);

  const menus = ["men", "women", "kids"];
  const categories = [
    ...new Set(
      products
        .filter((p) => !filters.menu || p.menu_slug === filters.menu)
        .map((p) => p.category_name)
    ),
  ];
  const subcategories = [
    ...new Set(
      products
        .filter(
          (p) =>
            (!filters.menu || p.menu_slug === filters.menu) &&
            (!filters.category || p.category_name === filters.category)
        )
        .map((p) => p.subcategory_name)
    ),
  ];

  useEffect(() => {
    let result = [...products];

    if (filters.menu) {
      result = result.filter((product) => product.menu_slug === filters.menu);
    }

    if (filters.category) {
      result = result.filter(
        (product) => product.category_name === filters.category
      );
    }

    if (filters.subcategory) {
      result = result.filter(
        (product) => product.subcategory_name === filters.subcategory
      );
    }

    result = result.filter(
      (product) =>
        product.price >= filters.priceRange[0] &&
        product.price <= filters.priceRange[1]
    );

    if (selectedOption === "lowToHigh") {
      result.sort((a, b) => a.price - b.price);
    } else if (selectedOption === "highToLow") {
      result.sort((a, b) => b.price - a.price);
    }
    console.log("result  : ", result);
    setFilteredProducts(result);

    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, [filters, products, selectedOption]);

  if (isLoading) {
    return (
      <div className="body-container">
        <SkeletonLoader />
      </div>
    );
  }

  const handleFilterChange = (filterType, value) => {
    if (filterType === "menu") {
      setFilters((prev) => ({
        ...prev,
        menu: value,
        category: "",
        subcategory: "",
      }));
    } else if (filterType === "category") {
      setFilters((prev) => ({
        ...prev,
        category: value,
        subcategory: "",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        [filterType]: value,
      }));
    }
  };

  const handlePriceRangeChange = (min, max) => {
    setFilters((prev) => ({
      ...prev,
      priceRange: [min, max],
    }));
  };

  const handleProductClick = (slug) => {
console.log("")
    navigate(`/detailsPage/${slug}`);
  };

  const handleToggleDropdown = () => {
    setShowSortDropdown((prev) => !prev);
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    setShowSortDropdown(false);
  };

  const handleFavorite = (product) => {
    const isFavorite = favorites.some((item) => item.id === product.id);
    //console.log("product size : ", product.size);
    //console.log("selectedSize : ", selectedSizeId);
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }

    const favoriteProduct = {
      id: product.id,
      menu_id: product.menu_id,
      category_id: product.category_id,
      subcategory_id: product.subcategory_id,
      name: product.name,
      slug: product.slug,
      image: product.image,
      menu_name: product.menu_name,
      menu_slug: product.menu_slug,
      category_name: product.category_name,
      category_slug: product.category_slug,
      subcategory_name: product.subcategory_name,
      subcategory_slug: product.subcategory_slug,
      size: product.size.find((size) => size.size_id),
    };

    console.log("favoriteProduct : ", favoriteProduct);

    if (isFavorite) {
      dispatch(removeFavorite(product.id));
    } else {
      dispatch(addFavorite(favoriteProduct));
    }
  };

  return (
    <div className="body-container">
      <div className="mobile-filter-button-container">
        <button className="mobile-filter-button" onClick={toggleMobileFilter}>
          <FaFilter className="filter-icon" />
          <span>Filters</span>
        </button>
      </div>

      <main className="content-main" style={{ backgroundColor: "white" }}>
        <div className="container-main">
          <div className="page-layout">
            <div className="page-layout-wrapper" style={{ marginTop: "78px" }}>
              <aside className="sidebar1">
                <div className="filter-section">
                  <h3>Filters</h3>

                  <div className="filter-group dropdown-section">
                    <h4>SORT BY</h4>
                    <div
                      className="dropdown-wrapper"
                      onClick={handleToggleDropdown}
                    >
                      <select
                        id="dropdown"
                        value={selectedOption}
                        onChange={handleSelectChange}
                        className="custom-select"
                      >
                        <option value="NewestFirst">Newest First</option>
                        <option value="lowToHigh">Price: Low to High</option>
                        <option value="highToLow">Price: High to Low</option>
                      </select>
                      <span className="dropdown-icon">
                        {showSortDropdown ? <FaAngleUp /> : <FaAngleDown />}
                      </span>
                    </div>
                  </div>

                  <div className="filter-group dropdown-section">
                    <h4
                      className="dropdown-header"
                      onClick={() => setShowMenuDropdown(!showMenuDropdown)}
                      style={{ cursor: "pointer" }}
                    >
                      Menu {showMenuDropdown ? <FaAngleUp /> : <FaAngleDown />}
                    </h4>
                    {showMenuDropdown && (
                      <div className="category-boxes">
                        {menus.map((menu) => (
                          <button
                            key={menu}
                            className={`category-box ${
                              filters.menu === menu ? "selected" : ""
                            }`}
                            onClick={() => handleFilterChange("menu", menu)}
                            style={{ fontSize: "14px" }}
                          >
                            {menu.charAt(0).toUpperCase() + menu.slice(1)}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {filters.menu && (
                    <div className="filter-group dropdown-section">
                      <h4
                        className="dropdown-header"
                        onClick={() =>
                          setShowCategoryDropdown(!showCategoryDropdown)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        Category{" "}
                        {showCategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
                      </h4>
                      {showCategoryDropdown && (
                        <div className="category-boxes">
                          {categories.map((category) => (
                            <button
                              key={category}
                              className={`category-box ${
                                filters.category === category ? "selected" : ""
                              }`}
                              onClick={() =>
                                handleFilterChange("category", category)
                              }
                              style={{ fontSize: "14px" }}
                            >
                              {category}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {filters.category && (
                    <div className="filter-group dropdown-section">
                      <h4
                        className="dropdown-header"
                        onClick={() =>
                          setShowSubcategoryDropdown(!showSubcategoryDropdown)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        Subcategory{" "}
                        {showSubcategoryDropdown ? (
                          <FaAngleUp />
                        ) : (
                          <FaAngleDown />
                        )}
                      </h4>
                      {showSubcategoryDropdown && (
                        <div className="category-boxes">
                          {subcategories.map((subcategory) => (
                            <button
                              key={subcategory}
                              className={`category-box ${
                                filters.subcategory === subcategory
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                handleFilterChange("subcategory", subcategory)
                              }
                              style={{ fontSize: "14px" }}
                            >
                              {subcategory}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </aside>
              {/* height: "90vh"  */}
              <section className="main-content" style={{}}>
                <div className="product-listing">
                  <div className="product-grid">
                    {filteredProducts.length > 0 ? (
                      filteredProducts?.map((product) => {
                        const isFavorite = favorites.some(
                          (item) => item.id === product.id
                        );
                        const discount = product?.size[0]?.discount_percent;

                        return (
                          <div key={product.id} className="product-card" style={{position:"relative"}}>
                            <div className="product-box">
                              {discount > 0 && (
                                <div className="discount-badge pulse-animation">
                                  <span style={{ fontSize: "14px" }}>
                                    {discount}% OFF
                                  </span>
                                </div>
                              )}
                              <span
                                onClick={() => handleFavorite(product)}
                                style={{
                                  padding: "5px 10px",
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  borderRadius: "20px",
                                  fontSize: "0.9rem",
                                  zIndex: "2",
                                  fontSize: "17px",
                                }}
                              >
                                {isFavorite ? (
                                  <FaHeart color="red" />
                                ) : (
                                  <FaRegHeart color="grey" />
                                )}
                              </span>
                              <div className="product-image-wrapper">
                                <a
                                  href="#"
                                  className="product-link1"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleProductClick(product.slug);
                                  }}
                                >
                                  <img
                                    src={product.image}
                                    alt={product.name}
                                    className="product-image"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      maxHeight: "100%",
                                    }}
                                  />
                                  {product.second_image && (
                                    <img
                                      src={`${configUrl}${product?.second_image}`}
                                      alt={product.name}
                                      className="hover-image"
                                    />
                                  )}
                                </a>
                              </div>
                              <div className="product-info">
                                <a
                                  href="#"
                                  className="product-name"
                                  style={{
                                    display: "inline-block",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "97%",
                                    verticalAlign: "middle",
                                    fontSize: "16px",
                                  }}
                                >
                                  {product.name}
                                </a>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    className="product-price"
                                    style={{
                                      marginTop: "0px",
                                      color: "#fa0707",
                                    }}
                                  >
                                    PRICE:{" "}
                                    <span>${product?.size[0]?.price}</span>
                                  </div>
                                  <div
                                    className="product-mrp"
                                    style={{ fontSize: "12px" }}
                                  >
                                    <span className="mrp">
                                      MRP: ${product?.size[0]?.mrp}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="product-not-found">
                        <h3>No Products Found</h3>
                        <p>
                          Try adjusting your filters or browse other categories.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <div
        className={`mobile-filter-overlay ${isMobileFilterOpen ? "open" : ""}`}
        onClick={toggleMobileFilter}
      ></div>

      <div
        className={`mobile-filter-panel ${isMobileFilterOpen ? "open" : ""}`}
      >
        <div className="mobile-filter-header">
          <div className="filter-header-content">
            <h3>Filters</h3>
            <button
              className="clear-filters"
              onClick={() => {
                handleFilterChange("menu", "");
                handleFilterChange("category", "");
                handleFilterChange("subcategory", "");
              }}
            >
              Clear All
            </button>
          </div>
          <button className="close-filter-button" onClick={toggleMobileFilter}>
            <FaTimes />
          </button>
        </div>

        <div className="mobile-filter-content">
          <div className="mobile-filter-section">
            <div className="mobile-filter-section-header">
              <h4>SORT BY</h4>
            </div>
            <div className="mobile-filter-dropdown">
              <select
                value={selectedOption}
                onChange={handleSelectChange}
                className="mobile-custom-select"
              >
                <option value="NewestFirst">Newest First</option>
                <option value="lowToHigh">Price: Low to High</option>
                <option value="highToLow">Price: High to Low</option>
              </select>
            </div>
          </div>

          <div className="mobile-filter-section">
            <div
              className="mobile-filter-section-header"
              onClick={() => setShowMenuDropdown(!showMenuDropdown)}
            >
              <h4>MENU</h4>
              {showMenuDropdown ? <FaAngleUp /> : <FaAngleDown />}
            </div>
            {showMenuDropdown && (
              <div className="mobile-filter-options">
                {menus.map((menu) => (
                  <button
                    key={menu}
                    className={`mobile-filter-option ${
                      filters.menu === menu ? "selected" : ""
                    }`}
                    onClick={() => handleFilterChange("menu", menu)}
                  >
                    {menu.charAt(0).toUpperCase() + menu.slice(1)}
                  </button>
                ))}
              </div>
            )}
          </div>

          {filters.menu && (
            <div className="mobile-filter-section">
              <div
                className="mobile-filter-section-header"
                onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
              >
                <h4>CATEGORY</h4>
                {showCategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
              </div>
              {showCategoryDropdown && (
                <div className="mobile-filter-options">
                  {categories.map((category) => (
                    <button
                      key={category}
                      className={`mobile-filter-option ${
                        filters.category === category ? "selected" : ""
                      }`}
                      onClick={() => handleFilterChange("category", category)}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          {filters.category && (
            <div className="mobile-filter-section">
              <div
                className="mobile-filter-section-header"
                onClick={() =>
                  setShowSubcategoryDropdown(!showSubcategoryDropdown)
                }
              >
                <h4>SUBCATEGORY</h4>
                {showSubcategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
              </div>
              {showSubcategoryDropdown && (
                <div className="mobile-filter-options">
                  {subcategories.map((subcategory) => (
                    <button
                      key={subcategory}
                      className={`mobile-filter-option ${
                        filters.subcategory === subcategory ? "selected" : ""
                      }`}
                      onClick={() =>
                        handleFilterChange("subcategory", subcategory)
                      }
                    >
                      {subcategory}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          <div className="mobile-filter-footer">
            <button
              className="mobile-apply-button"
              onClick={() => {
                toggleMobileFilter();
              }}
              disabled={filteredProducts.length === 0}
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Mobile Filter Button */
        .mobile-filter-button-container {
          position: absolute;
          top: 78px;
          z-index: 100;
          /* top: 3px; */
          right: 5px;
          margin-top: 5px;
        }

        .mobile-filter-button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 20px;
          background-color: #2c3e50;
          color: white;
          border: none;
          border-radius: 30px;
          font-size: 16px;
          font-weight: 600;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }

        .filter-badge {
          position: absolute;
          top: -8px;
          right: -8px;
          background-color: #e74c3c;
          color: white;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
        }

        .mobile-filter-options {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 10px;
        }

        .mobile-filter-option {
          padding: 8px 12px;
          background-color: #f5f5f5;
          border: none;
          border-radius: 4px;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s;
        }

        /* Mobile Filter Overlay */
        .mobile-filter-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 996;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
        }

        .mobile-filter-overlay.open {
          opacity: 1;
          visibility: visible;
        }

        /* Mobile Filter Panel */
        .mobile-filter-panel {
          position: fixed;
          top: 0;
          left: -100%;
          width: 85%;
          max-width: 320px;
          height: 100vh;
          background-color: white;
          z-index: 997;
          overflow-y: auto;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 2px 0 15px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
        }

        .mobile-filter-panel.open {
          left: 0;
        }

        .mobile-filter-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px;
          border-bottom: 1px solid #eee;
          position: sticky;
          top: 0;
          background: white;
          z-index: 1;
        }

        .filter-header-content {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .mobile-filter-header h3 {
          margin: 0;
          font-size: 18px;
          color: #333;
          font-weight: 600;
        }

        .clear-filters {
          background: none;
          border: none;
          color: #3498db;
          font-size: 14px;
          cursor: pointer;
          padding: 4px 8px;
        }

        .close-filter-button {
          background: none;
          border: none;
          font-size: 20px;
          color: #666;
          cursor: pointer;
        }

        .mobile-filter-content {
          padding: 16px;
          flex: 1;
          overflow-y: auto;
        }

        .mobile-filter-section {
          margin-bottom: 20px;
        }

        .mobile-filter-section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 0;
          cursor: pointer;
        }

        .mobile-filter-section-header h4 {
          margin: 0;
          font-size: 15px;
          color: #333;
          font-weight: 600;
        }

        .mobile-filter-dropdown {
          margin-top: 10px;
        }

        .mobile-custom-select {
          width: 100%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
          background-color: #f9f9f9;
        }

        /* Grid layout for filter options */
        .mobile-filter-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 8px;
          margin-top: 10px;
        }

        .mobile-filter-option {
          padding: 8px 4px;
          background-color: #f5f5f5;
          border: none;
          border-radius: 4px;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.2s;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .mobile-filter-option.selected {
          background-color: #2c3e50;
          color: white;
        }

        .mobile-filter-footer {
          position: sticky;
          bottom: 0;
          background: white;
          padding: 16px 0;
          border-top: 1px solid #eee;
          margin-top: auto;
        }

        .mobile-apply-button {
          width: 100%;
          padding: 14px;
          background-color: #2c3e50;
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
        }

        .mobile-apply-button:disabled {
          background-color: #95a5a6;
          cursor: not-allowed;
        }
        .mobile-filter-button-container {
          display: none;
        }
        @media (max-width: 768px) {
          .mobile-filter-button-container {
            display: block;
          }
          .product-grid {
            margin-top: 55px;
          }
        }
      `}</style>
    </div>
  );
};
